import React from 'react';
import { Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="w-full mt-auto border-t border-gray-200 bg-white shadow-sm">
      <div className="max-w-full mx-auto px-6 py-5">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6">
          {/* Contact Section - Left */}
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 text-sm text-gray-600">
            <span className="font-medium text-gray-700 whitespace-nowrap">
              Contact team for more details or support:
            </span>
            <a 
              href="mailto:kulsoom.zaidi@geedsim.com" 
              className="flex items-center gap-1.5 text-blue-600 hover:text-blue-700 hover:underline transition-all duration-200 font-medium group"
              aria-label="Send email to support team"
            >
              <Mail className="h-4 w-4 transition-transform group-hover:scale-110" />
              <span className="whitespace-nowrap">ecsbctrackerhelpdesk@gmail.com</span>
            </a>
          </div>

          {/* Copyright Section - Right */}
          <div className="flex items-center text-sm text-gray-600">
            <span className="font-medium text-gray-700 whitespace-nowrap">
              © {new Date().getFullYear()} ECSBC Cell Tracker. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

